<script lang="ts">
  import { getContext } from 'svelte';
  import clsx from 'clsx';
  import { setContainerContextWidth } from '@athena-lib/container-context.svelte';
  import { gridContextKey, type GridContext, type GridItemProps } from './types';
  import { getGridColumnSpanClasses, getGridRowSpanClasses } from './utils';
  import { containerWidthFromColumns } from './container-width';

  let {
    children,
    colSpan,
    rowSpan,
    class: className,
    action = () => undefined,
    actionArg,
  }: GridItemProps = $props();
  const context = getContext<GridContext>(gridContextKey);

  setContainerContextWidth(containerWidthFromColumns(colSpan, context.columns()));

  function elementAction(node: HTMLDivElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

<div
  use:elementAction
  class={clsx(
    className,
    getGridColumnSpanClasses(colSpan, context.columns()),
    getGridRowSpanClasses(rowSpan),
  )}
>
  {@render children()}
</div>
